/* Vitalis — global.js
   Native APIs only. Everything works without JS; this file only enhances. */

(() => {
  'use strict';

  /* Quantity steppers (PDP + cart) */
  document.querySelectorAll('.qty').forEach((qty) => {
    const input = qty.querySelector('.qty__input');
    if (!input) return;
    qty.addEventListener('click', (e) => {
      const btn = e.target.closest('.qty__btn');
      if (!btn) return;
      e.preventDefault();
      const step = btn.dataset.dir === 'down' ? -1 : 1;
      const min = parseInt(input.min || '1', 10);
      const next = Math.max(min, (parseInt(input.value, 10) || min) + step);
      if (input.value !== String(next)) {
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  /* Cart page: submit the form when a line quantity changes */
  const cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.addEventListener('change', (e) => {
      if (e.target.matches('.qty__input')) cartForm.submit();
    });
  }

  /* Close the mobile menu drawer when a link inside it is followed */
  document.querySelectorAll('.menu-drawer').forEach((drawer) => {
    drawer.addEventListener('click', (e) => {
      if (e.target.closest('a')) drawer.removeAttribute('open');
    });
  });
})();

/* Sticky mobile ATC: show once the main buy button scrolls out of view */
(() => {
  'use strict';
  const bar = document.querySelector('[data-sticky-atc]');
  const mainBtn = document.querySelector('.pdp__form .btn');
  if (!bar || !mainBtn) return;
  bar.hidden = false;
  const updateSticky = () => {
    bar.classList.toggle('is-visible', mainBtn.getBoundingClientRect().top < 0);
  };
  addEventListener('scroll', updateSticky, { passive: true });
  updateSticky();
})();

/* Hotspot best sellers: pins, number row and card stay in sync */
(() => {
  'use strict';
  document.querySelectorAll('[data-hotspot]').forEach((root) => {
    const pins = root.querySelectorAll('[data-pin]');
    const nums = root.querySelectorAll('[data-num]');
    const cards = root.querySelectorAll('[data-card]');
    if (!cards.length) return;
    let i = 0;
    const go = (n) => {
      i = (n + cards.length) % cards.length;
      cards.forEach((c, k) => c.classList.toggle('is-active', k === i));
      pins.forEach((p, k) => p.classList.toggle('is-active', k === i));
      nums.forEach((p, k) => p.classList.toggle('is-active', k === i));
    };
    pins.forEach((p) => p.addEventListener('click', () => go(+p.dataset.pin)));
    nums.forEach((p) => p.addEventListener('click', () => go(+p.dataset.num)));
    root.querySelectorAll('[data-dir]').forEach((b) => {
      b.addEventListener('click', () => go(i + (+b.dataset.dir)));
    });
    go(0);

    /* Pins are authored as % of the IMAGE. The image is object-fit: cover,
       so translate image coordinates into container coordinates whatever
       the crop is, at every viewport size. */
    const frame = root.querySelector('.hotspot-split__frame');
    const img = frame && frame.querySelector('img');
    const place = () => {
      if (!img || !img.naturalWidth || !frame.clientWidth) return;
      const W = frame.clientWidth, H = frame.clientHeight;
      const A = img.naturalWidth / img.naturalHeight, C = W / H;
      let dispW, dispH, offX = 0, offY = 0;
      if (C > A) { dispW = W; dispH = W / A; offY = (dispH - H) / 2; }
      else { dispH = H; dispW = H * A; offX = (dispW - W) / 2; }
      pins.forEach((p) => {
        const x = parseFloat(p.dataset.x) / 100, y = parseFloat(p.dataset.y) / 100;
        if (Number.isNaN(x) || Number.isNaN(y)) return;
        p.style.left = (((x * dispW - offX) / W) * 100) + '%';
        p.style.top = (((y * dispH - offY) / H) * 100) + '%';
      });
    };
    if (img) {
      if (img.complete) place(); else img.addEventListener('load', place);
      addEventListener('resize', place, { passive: true });
    }
  });
})();

/* Reviews carousel: fade slides, clickable dots, auto-rotate */
(() => {
  'use strict';
  document.querySelectorAll('[data-reviews]').forEach((root) => {
    const slides = root.querySelectorAll('.review-slide');
    const dots = root.querySelectorAll('[data-dot]');
    if (slides.length < 2) return;
    let i = 0;
    let timer;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((sl, k) => sl.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    const play = () => { timer = setInterval(() => go(i + 1), 5000); };
    dots.forEach((d) => {
      d.addEventListener('click', () => { clearInterval(timer); go(+d.dataset.dot); play(); });
    });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
  });
})();

/* Facts drawer: native dialog, closes on backdrop click and Escape */
(() => {
  'use strict';
  const drawer = document.querySelector('[data-facts-drawer]');
  const opener = document.querySelector('[data-facts-open]');
  if (!drawer || !opener) return;
  opener.addEventListener('click', () => drawer.showModal());
  drawer.querySelector('[data-facts-close]').addEventListener('click', () => drawer.close());
  drawer.addEventListener('click', (e) => {
    if (e.target === drawer) drawer.close();
  });
})();

/* Cart drawer: native Cart AJAX API only (/cart.js, /cart/add.js, /cart/change.js).
   Progressive enhancement: without JS, cart links go to /cart as before. */
(() => {
  'use strict';
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const itemsEl = drawer.querySelector('[data-cart-items]');
  const emptyEl = drawer.querySelector('[data-cart-empty]');
  const footEl = drawer.querySelector('[data-cart-foot]');
  const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  const winEl = drawer.querySelector('[data-cart-win]');
  const winTitle = drawer.querySelector('[data-cart-win-title]');
  const winSub = drawer.querySelector('[data-cart-win-sub]');
  const shipline = drawer.querySelector('[data-cart-shipline]');
  const milePromo = drawer.querySelector('[data-mile-promo]');
  const milePromoLabel = drawer.querySelector('[data-mile-promo-label]');
  const promoRow = drawer.querySelector('[data-cart-promo-row]');
  const promoLabel = drawer.querySelector('[data-cart-promo-label]');
  const promoAmt = drawer.querySelector('[data-cart-promo-amt]');
  const subsaveRow = drawer.querySelector('[data-cart-subsave-row]');
  const subsaveAmt = drawer.querySelector('[data-cart-subsave-amt]');
  const recsEl = drawer.querySelector('[data-cart-recs]');
  const recsRail = drawer.querySelector('[data-cart-recs-rail]');

  const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100);
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const badge = document.querySelector('.site-header__cart-count');

  function discountTitle(cart) {
    const capp = (cart.cart_level_discount_applications || [])[0];
    if (capp && capp.title) return capp.title;
    for (const it of cart.items) {
      const d = (it.discounts || [])[0];
      if (d && d.title) return d.title;
    }
    return 'Discount';
  }

  function lineCompare(it) {
    const a = it.selling_plan_allocation;
    const subCompare = a && a.compare_at_price > a.price ? a.compare_at_price * it.quantity : 0;
    return Math.max(it.original_line_price || 0, subCompare);
  }

  function lineChip(it) {
    const d = (it.discounts || [])[0];
    if (d && d.title && d.amount > 0) return '<span class="cart-drawer__item-chip">' + esc(d.title) + ' applied</span>';
    return '';
  }

  function render(cart) {
    if (badge) badge.textContent = cart.item_count;

    if (!cart.item_count) {
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      footEl.hidden = true;
      if (winEl) { winEl.hidden = true; }
      if (shipline) { shipline.hidden = false; }
      return;
    }
    emptyEl.hidden = true;
    footEl.hidden = false;

    itemsEl.innerHTML = cart.items.map((it) => `
      <div class="cart-drawer__item" data-line-key="${esc(it.key)}">
        <a class="cart-drawer__item-media" href="${esc(it.url)}">
          ${it.image ? `<img src="${esc(it.image)}&width=160" alt="" loading="lazy">` : ''}
        </a>
        <div class="cart-drawer__item-body">
          <a class="cart-drawer__item-title" href="${esc(it.url)}">${esc(it.product_title)}</a>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<p class="cart-drawer__item-meta">${esc(it.variant_title)}</p>` : ''}
          ${lineChip(it)}
          ${it.selling_plan_allocation ? `<p class="cart-drawer__item-sub">&#8635; ${esc(it.selling_plan_allocation.selling_plan.name)} &middot; pause or cancel anytime</p>` : ''}
          <div class="cart-drawer__item-row">
            <div class="qty qty--sm">
              <button class="qty__btn" type="button" data-line-dir="-1" aria-label="Decrease quantity">&minus;</button>
              <span class="cart-drawer__item-qty">${it.quantity}</span>
              <button class="qty__btn" type="button" data-line-dir="1" aria-label="Increase quantity">+</button>
            </div>
            <span class="cart-drawer__item-price">
              ${lineCompare(it) > it.final_line_price ? `<s>${money(lineCompare(it))}</s> ` : ''}${money(it.final_line_price)}
            </span>
            <button class="cart-drawer__item-remove" type="button" data-line-remove aria-label="Remove">Remove</button>
          </div>
        </div>
      </div>`).join('');

    subtotalEl.textContent = money(cart.total_price);

    const promoSaved = cart.total_discount || 0;
    const subSaved = cart.items.reduce((t, it) => {
      const a = it.selling_plan_allocation;
      if (a && a.compare_at_price > a.price) t += (a.compare_at_price - a.price) * it.quantity;
      return t;
    }, 0);
    const promoName = promoSaved > 0 ? discountTitle(cart) : '';
    const totalSaved = promoSaved + subSaved;

    if (winEl && totalSaved > 0) {
      winEl.hidden = false;
      if (shipline) shipline.hidden = true;
      winTitle.textContent = (promoName ? promoName + ' applied + ' : '') + 'Free shipping unlocked';
      winSub.textContent = "You're saving " + money(totalSaved) + ' on your order.';
      milePromo.hidden = promoSaved <= 0;
      if (promoSaved > 0) milePromoLabel.textContent = promoName + ' applied';
    } else if (winEl) {
      winEl.hidden = true;
      if (shipline) shipline.hidden = false;
    }

    promoRow.hidden = promoSaved <= 0;
    if (promoSaved > 0) {
      promoLabel.textContent = (promoName || 'Sale') + ' savings';
      promoAmt.textContent = '-' + money(promoSaved);
    }
    subsaveRow.hidden = subSaved <= 0;
    if (subSaved > 0) subsaveAmt.textContent = '-' + money(subSaved);

    loadRecs(cart);
  }

  async function loadRecs(cart) {
    try {
      const inCart = new Set(cart.items.map((i) => i.product_id));
      const first = cart.items[0];
      if (!first) { recsEl.hidden = true; return; }
      const r = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}recommendations/products.json?product_id=${first.product_id}&limit=4&intent=related`);
      if (!r.ok) { recsEl.hidden = true; return; }
      const data = await r.json();
      const prods = (data.products || []).filter((p) => !inCart.has(p.id)).slice(0, 3);
      if (!prods.length) { recsEl.hidden = true; return; }
      recsRail.innerHTML = prods.map((p) => `
        <div class="cart-drawer__rec">
          <a class="cart-drawer__rec-media" href="${esc(p.url)}">
            ${p.featured_image ? `<img src="${esc(p.featured_image)}&width=300" alt="" loading="lazy">` : ''}
          </a>
          <a class="cart-drawer__rec-title" href="${esc(p.url)}">${esc(p.title)}</a>
          <span class="cart-drawer__rec-price">${money(p.price)}</span>
          ${p.variants && p.variants.length === 1 && p.available ? `<button class="btn btn--outline cart-drawer__rec-add" type="button" data-rec-add="${p.variants[0].id}">Add to cart</button>` : `<a class="btn btn--outline cart-drawer__rec-add" href="${esc(p.url)}">View</a>`}
        </div>`).join('');
      recsEl.hidden = false;
    } catch (e) { recsEl.hidden = true; }
  }

  async function refresh() {
    const r = await fetch('/cart.js');
    render(await r.json());
  }

  function open() {
    if (!drawer.open) drawer.showModal();
    refresh();
  }

  drawer.querySelector('[data-cart-close]').addEventListener('click', () => drawer.close());
  drawer.addEventListener('click', (e) => { if (e.target === drawer) drawer.close(); });

  /* Header cart link opens the drawer instead of navigating */
  document.querySelectorAll('a[href*="/cart"]').forEach((a) => {
    if (a.closest('.cart-drawer') || a.closest('.sticky-atc')) return;
    if (a.pathname && a.pathname.endsWith('/cart') && a.closest('.site-header')) {
      a.addEventListener('click', (e) => { e.preventDefault(); open(); });
    }
  });

  /* Product form: add via AJAX then open the drawer */
  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } });
        if (!r.ok) { form.submit(); return; }
        open();
      } catch (err) {
        form.submit();
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  });

  /* Line changes inside the drawer */
  drawer.addEventListener('click', async (e) => {
    const dir = e.target.closest('[data-line-dir]');
    const rem = e.target.closest('[data-line-remove]');
    const recAdd = e.target.closest('[data-rec-add]');
    if (recAdd) {
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: +recAdd.dataset.recAdd, quantity: 1 }) });
      refresh();
      return;
    }
    const line = e.target.closest('[data-line-key]');
    if (!line) return;
    const key = line.dataset.lineKey;
    if (dir) {
      const qty = +line.querySelector('.cart-drawer__item-qty').textContent + (+dir.dataset.lineDir);
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) });
      refresh();
    } else if (rem) {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
      refresh();
    }
  });
})();

/* FAQ question pills: auto-scrolling marquee built from the page's FAQ section.
   Click pauses handled by CSS hover; click scrolls to and opens that question. */
(() => {
  'use strict';
  const wrap = document.querySelector('[data-faq-pills]');
  const faq = document.querySelector('#faq');
  if (!wrap || !faq) return;
  const items = [...faq.querySelectorAll('details.accordion')].slice(0, 6);
  if (!items.length) return;
  const icon = '<svg width="13" height="13" viewBox="0 0 14 14" fill="none" aria-hidden="true"><circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.2"/><path d="M5.4 5.4c0-1 .7-1.6 1.6-1.6.9 0 1.6.6 1.6 1.5 0 1.2-1.6 1.3-1.6 2.4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M7 10.4h.01" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  const track = document.createElement('div');
  track.className = 'faq-pills__track';
  const addSet = (hidden) => {
    items.forEach((d) => {
      const q = d.querySelector('summary');
      if (!q) return;
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'faq-pill';
      if (hidden) b.setAttribute('aria-hidden', 'true');
      b.innerHTML = icon + q.textContent.trim();
      b.addEventListener('click', () => {
        items.forEach((o) => o.removeAttribute('open'));
        d.setAttribute('open', '');
        d.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      track.appendChild(b);
    });
  };
  addSet(false);
  addSet(true);
  wrap.appendChild(track);
  wrap.hidden = false;
})();

/* Build-your-routine quick add: native /cart/add.js then open the cart drawer */
(() => {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-routine-add]');
    if (!btn) return;
    btn.disabled = true;
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: +btn.dataset.routineAdd, quantity: 1 }) });
      if (r.ok) {
        const cartLink = document.querySelector('.site-header a[href*="/cart"]');
        if (cartLink) cartLink.click(); else window.location.href = '/cart';
      }
    } catch (err) {} finally { btn.disabled = false; }
  });
})();

/* Product image lightbox: native scroll-snap carousel inside a dialog.
   Swiping is native horizontal scrolling; arrows and keys just scroll. */
(() => {
  const box = document.querySelector('[data-lightbox]');
  if (!box) return;
  const stage = box.querySelector('[data-lb-stage]');
  const slides = [...box.querySelectorAll('[data-lb-slide]')];
  const counter = box.querySelector('[data-lb-counter]');
  if (!stage || !slides.length) return;
  const idx = () => Math.max(0, Math.min(slides.length - 1, Math.round(stage.scrollLeft / stage.clientWidth)));
  const update = () => { if (counter) counter.textContent = (idx() + 1) + ' / ' + slides.length; };
  const unzoom = () => box.querySelectorAll('.is-zoomed').forEach((i) => i.classList.remove('is-zoomed'));
  const go = (n, instant) => {
    unzoom();
    const i = Math.max(0, Math.min(slides.length - 1, n));
    stage.scrollTo({ left: i * stage.clientWidth, behavior: instant ? 'auto' : 'smooth' });
    if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
  };
  document.querySelectorAll('[data-lb-open]').forEach((btn) => {
    btn.addEventListener('click', () => {
      box.showModal();
      unzoom();
      const target = +btn.dataset.lbOpen || 0;
      let tries = 0;
      const openAt = () => {
        const w = stage.clientWidth;
        if (!w && tries++ < 20) return requestAnimationFrame(openAt);
        stage.scrollLeft = target * w;
        if (counter) counter.textContent = (target + 1) + ' / ' + slides.length;
      };
      requestAnimationFrame(openAt);
      setTimeout(openAt, 120);
    });
  });
  let st;
  stage.addEventListener('scroll', () => { clearTimeout(st); st = setTimeout(update, 90); }, { passive: true });
  box.querySelector('[data-lb-prev]').addEventListener('click', () => go(idx() - 1 < 0 ? slides.length - 1 : idx() - 1));
  box.querySelector('[data-lb-next]').addEventListener('click', () => go(idx() + 1 > slides.length - 1 ? 0 : idx() + 1));
  box.querySelector('[data-lb-close]').addEventListener('click', () => box.close());
  box.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1 > slides.length - 1 ? 0 : idx() + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1 < 0 ? slides.length - 1 : idx() - 1); }
  });
  box.addEventListener('click', (e) => {
    const img = e.target.closest('.lightbox__slide img');
    if (img) { img.classList.toggle('is-zoomed'); return; }
    if (!e.target.closest('button')) box.close();
  });
})();

/* PDP gallery: stage + thumbs, synced with the lightbox indices */
(() => {
  const stage = document.querySelector('.pdp__stage');
  if (!stage) return;
  const items = [...stage.querySelectorAll('[data-stage-item]')];
  const thumbs = [...document.querySelectorAll('[data-g-thumb]')];
  if (items.length < 2) return;
  let i = 0;
  const show = (n) => {
    i = (n + items.length) % items.length;
    items.forEach((el, k) => { el.hidden = k !== i; });
    thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
    const active = thumbs[i];
    if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  };
  const prev = document.querySelector('[data-g-prev]');
  const next = document.querySelector('[data-g-next]');
  if (prev) prev.addEventListener('click', () => show(i - 1));
  if (next) next.addEventListener('click', () => show(i + 1));
  thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
})();

/* Quantity tiers: qty follows the tier; prices per tier follow the purchase mode */
(() => {
  const tiers = document.querySelector('[data-qty-tiers]');
  if (!tiers) return;
  const form = tiers.closest('form');
  const qty = form ? form.querySelector('input[name="quantity"]') : null;
  if (!qty) return;
  const planRadios = [...form.querySelectorAll('input[name="selling_plan"]')];
  const modeEls = tiers.querySelectorAll('[data-mode]');
  const setMode = () => {
    const sub = planRadios.some((p) => p.checked && p.value !== '');
    modeEls.forEach((el) => { el.hidden = (el.dataset.mode === 'sub') !== sub; });
  };
  tiers.addEventListener('change', (e) => {
    const r = e.target.closest('input[name="qty_tier"]');
    if (r) qty.value = r.value;
  });
  planRadios.forEach((p) => p.addEventListener('change', setMode));
  setMode();
})();

/* Honest countdown: reads a real deadline; hides itself the moment it passes */
(() => {
  const el = document.querySelector('[data-countdown]');
  if (!el) return;
  const end = new Date(el.dataset.end).getTime();
  if (!end || isNaN(end)) return;
  const out = el.querySelector('[data-countdown-out]');
  const pad = (n) => String(n).padStart(2, '0');
  const tick = () => {
    const left = end - Date.now();
    if (left <= 0) { el.hidden = true; clearInterval(timer); return; }
    const d = Math.floor(left / 86400000);
    const h = Math.floor(left % 86400000 / 3600000);
    const m = Math.floor(left % 3600000 / 60000);
    const sec = Math.floor(left % 60000 / 1000);
    out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(sec) + 's';
    el.hidden = false;
  };
  tick();
  const timer = setInterval(tick, 1000);
})();

/* Smart announcement bar: hides scrolling down, returns on the first scroll up */
(() => {
  const ann = document.querySelector('.announcement');
  const header = document.querySelector('.site-header');
  if (!ann || !header) return;
  const wrap = ann.closest('.shopify-section');
  if (!wrap || !wrap.contains(header)) return;
  if (document.body.classList.contains('template-index')) return;
  wrap.classList.add('header-sticky-wrap');
  ann.style.height = ann.offsetHeight + 'px';
  let lastY = window.scrollY;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (y > 140 && y > lastY + 6) ann.classList.add('announcement--hidden');
    else if (y < lastY - 6 || y <= 140) ann.classList.remove('announcement--hidden');
    lastY = y;
  }, { passive: true });
})();
